export default __webpack_public_path__ + "static/media/rooneyMen.d487f741.jpg";